module.exports = __webpack_public_path__ + "img/elha-logo-green-white.ca951cfd.svg";